export default "__VITE_ASSET__4OXXrrGY__"